import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController } from "context";

// Componentes del módulo
import OrdenCompra from "./components/OrdenCompra";
import ListaCompras from "./components/ListaCompras";
import Proveedores from "./components/Proveedores";
import Cotizaciones from "./components/Cotizaciones";
import RecepcionMercancia from "./components/RecepcionMercancia";
import ReportesCompras from "./components/ReportesCompras";

export default function Compras() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <OrdenCompra />;
      case 1:
        return <ListaCompras />;
      case 2:
        return <Proveedores />;
      case 3:
        return <Cotizaciones />;
      case 4:
        return <RecepcionMercancia />;
      case 5:
        return <ReportesCompras />;
      default:
        return <OrdenCompra />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  <Icon sx={{ fontWeight: "bold", verticalAlign: "middle", mr: 1 }}>
                    shopping_cart
                  </Icon>
                  Gestión de Compras y Proveedores
                </MDTypography>
              </MDBox>
              <MDBox p={2}>
                <Tabs value={tabValue} onChange={handleTabChange}>
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>add_shopping_cart</Icon>
                        Nueva Orden
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>list_alt</Icon>
                        Órdenes de Compra
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>business</Icon>
                        Proveedores
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>request_quote</Icon>
                        Cotizaciones
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>inventory</Icon>
                        Recepción
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center">
                        <Icon sx={{ mr: 1 }}>assessment</Icon>
                        Reportes
                      </MDBox>
                    }
                  />
                </Tabs>
              </MDBox>
              <MDBox p={3}>{renderContent()}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
